<template>
  <v-bottom-navigation
    app
    fixed
    elevation="0"
    color="primary"
  >
    <v-btn to="/calendar">
      <span>{{ $t("nav.calendar") }}</span>
      <v-icon>mdi-calendar</v-icon>
    </v-btn>

    <v-btn to="/groups">
      <span>{{ $t("nav.groups") }}</span>
      <v-icon>mdi-account-multiple</v-icon>
    </v-btn>

    <v-btn to="/requests">
      <span>{{ $t("nav.requests") }}</span>
      <v-badge :content="pendingCount" :value="pendingCount > 0" overlap bordered>
        <v-icon>mdi-inbox-arrow-down</v-icon>
      </v-badge>
    </v-btn>

    <v-btn to="/profile">
      <span>{{ $t("nav.profile") }}</span>
      <v-icon>mdi-account</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "@/services/firebase";

export default {
  data() {
    return {
      pendingCount: 0,
      unsub: null,
    };
  },

  computed: {
    uid() {
      return this.$store.getters["auth/uid"];
    },
  },

  watch: {
    uid: {
      immediate: true,
      handler() {
        this.startListener();
      },
    },
  },

  beforeDestroy() {
    if (this.unsub) this.unsub();
  },

  methods: {
    startListener() {
      if (this.unsub) {
        this.unsub();
        this.unsub = null;
      }
      if (!this.uid) {
        this.pendingCount = 0;
        return;
      }
      const qInv = query(
        collection(db, "users", this.uid, "eventInvites"),
        where("status", "==", "pending")
      );
      this.unsub = onSnapshot(qInv, (snap) => (this.pendingCount = snap.size));
    },
  },
};
</script>
